export default __webpack_public_path__ + "static/media/compoteAndCreamDetail.90ea4663.jpg";